import React, { useContext } from 'react';
import CalendarDateParameter from './CalendarDateParameter';
import { ParameterTextInput } from './ParameterTextInput';
import { SoQLType } from 'common/types/soql';
import { ParameterItemContext } from '../ParameterItem/ParameterItemContext';

export const ParameterValueEditor = (props: { onUpdate: (value: string) => void; onReset: () => void }) => {
  const { parameter } = useContext(ParameterItemContext)!;

  switch (parameter?.dataType) {
    case SoQLType.SoQLFloatingTimestampT:
    case SoQLType.SoQLFixedTimestampT:
      return <CalendarDateParameter parameter={parameter} {...props} />;
    case SoQLType.SoQLNumberT:
    case SoQLType.SoQLTextT:
      return <ParameterTextInput parameter={parameter} {...props} />;
    default:
      return null;
  }
};
